import axios from 'axios';

import * as utils from '../utils/utils.js';

export const createParticipant = async (participant) => {
    const session_url = utils.backendUrl() + '/participant';
    try {
        const response = await axios.post(
            session_url,
            {
                participant: participant,
                headers: {
                    'Content-Type': 'application/json',
                },
            },
            {
                withCredentials: true,
            }
        );

        if (response.status === 201) {
            utils.saveLastCreatedUuid(response.data.participant_id);
        }

        return response;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};
